import * as React from 'react';
import type { SVGProps } from 'react';
const SvgLine2 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={297}
    height={252}
    fill="none"
    viewBox="0 0 33 28"
    {...props}
  >
    <path
      fill="var(--color-border-base-secondary)"
      fillRule="evenodd"
      d="M30.156 12.18a1.05 1.05 0 0 0-1.476.164l-3.373 4.217-5.352-3.892-7.097 5.941-3.187-2.869-6.64 3.32a1.05 1.05 0 1 0 .939 1.878l5.36-2.68 3.479 3.131 7.236-6.058 5.648 4.107 4.627-5.783a1.05 1.05 0 0 0-.164-1.476"
      clipRule="evenodd"
    />
    <path
      fill="var(--color-content-status-neutral-secondary)"
      fillRule="evenodd"
      d="M30.16 5.684a1.05 1.05 0 0 0-1.476.156l-3.309 4.086-4.932-4.381-7.693 7.998-3.73-3.067-6.374 8.914a1.05 1.05 0 0 0 1.708 1.22l5.067-7.085 3.496 2.874 7.64-7.944 5.068 4.501 4.691-5.795a1.05 1.05 0 0 0-.155-1.477Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgLine2;
